import { DisclosureButton } from '@headlessui/react'
import Link from 'next/link'

export default function MobileHeaderItem({ href, children, isActive }) {
  return (
    <DisclosureButton
      as={Link}
      href={href}
      className={`block border-l-2 py-2.5 pr-4 pl-3 text-base font-sans font-medium uppercase tracking-wide transition-colors sm:pr-6 sm:pl-5 ${
        isActive
          ? 'border-foreground bg-muted text-foreground'
          : 'border-transparent text-muted-foreground hover:border-muted-foreground/50 hover:bg-muted/50 hover:text-foreground'
      }`}
    >
      {children}
    </DisclosureButton>
  )
}
